import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../../common/page-title';
import GamesTable from './games-table';
import { getAdminGames } from '../../../../actions/games';
import { Link } from 'react-router-dom';
import ArrowButton from '../../../common/button-arrow';

class Games extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAdminGames());
  }

  render() {
    const { games } = this.props;

    return (
      <div className="container-fluid">
        <PageTitle>
          Games
        </PageTitle>
        <div className="mg-bottom-60 mg-top-10">
          <div className="pull-left">
            <Link to="/admin/games/new">
              <ArrowButton 
                color="red"
                submit={false}
                arrow={false}>
                  Add Game
                </ArrowButton>
            </Link>
          </div>
        </div>
        <GamesTable games={games} />
      </div>
    );
  }    
}

const mapStateToProps = (state) => ({
  games: state.games.games
});

export default connect(mapStateToProps)(Games);



// WEBPACK FOOTER //
// ./src/components/admin/games/list/index.jsx